import { CommonModule } from '@angular/common'
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit
} from '@angular/core'
import { RouterLink } from '@angular/router'

import { environment } from '../../../../../environments/environment'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { User } from '../../../interfaces/resources/user.interface'
import { TopMenuLink } from '../../../interfaces/top-menu-link.interface'
import { AuthService } from '../../../services/auth.service'
import { EventService } from '../../../services/event.service'
import { BreadcrumbsComponent } from '../../partials/breadcrumbs/breadcrumbs.component'
import { ImageComponent } from '../../partials/image/image.component'

@Component({
  selector: 'case-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, BreadcrumbsComponent, HasPermissionDirective, ImageComponent]
})
export class TopMenuComponent implements OnInit {
  @Input() links: TopMenuLink[]
  @Input() isStaging: boolean

  currentUser: User
  isCollapsed = false

  showUserMenu: boolean
  showLinkMenu: boolean

  production = environment.production

  constructor(
    private authService: AuthService,
    private eventService: EventService,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    this.authService.currentUser.subscribe((userRes: User) => {
      setTimeout(() => {
        this.currentUser = userRes
      }, 0)
    })

    // CLose menus on changing route
    this.eventService.routeChanged.subscribe((routeChanged) => {
      this.showLinkMenu = false
      this.showUserMenu = false
    })
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target) {
    // We track clicks to close dropdown if open and click outside
    if (
      (this.showLinkMenu || this.showUserMenu) &&
      !this.elementRef.nativeElement
        .querySelector('#create-dropdown')
        .contains(target)
    ) {
      this.showLinkMenu = false
      this.showUserMenu = false
    }
  }
}
